var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#FFDA44;}\n\t.st2{fill:#ACABB1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0c141.4,0,256,114.6,256,256S397.4,512,256,512c0-11.1-33.4-256-33.4-256L256,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512C114.6,512,0,397.4,0,256S114.6,0,256,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M354,222.8l48.1,63.6c-7.6,11.5-7.5,26.9,1.2,38.5c11.1,14.7,32.1,17.6,46.8,6.5c14.7-11.1,17.6-32.1,6.5-46.8 c-8.8-11.6-23.6-15.9-36.7-11.7l-75-99.2l-17.8,13.4l-26.6,20.1l26.8,35.5L354,222.8z M423.3,295.9c4.9-3.7,11.9-2.7,15.6,2.2 c3.7,4.9,2.7,11.9-2.2,15.6c-4.9,3.7-11.9,2.7-15.6-2.2C417.4,306.6,418.4,299.6,423.3,295.9L423.3,295.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.5,242.9l26.8-35.5l-26.6-20.1L419,173.8L344,273c-13.1-4.2-28,0.1-36.7,11.7c-11.1,14.7-8.2,35.7,6.5,46.8 c14.7,11.1,35.7,8.2,46.8-6.5c8.8-11.6,8.8-27.1,1.2-38.5l48.1-63.6L436.5,242.9z M342.8,311.5c-3.7,4.9-10.7,5.9-15.6,2.2 c-4.9-3.7-5.9-10.7-2.2-15.6c3.7-4.9,10.7-5.9,15.6-2.2C345.5,299.6,346.5,306.6,342.8,311.5L342.8,311.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/va.ef5dc9b7b5658ed01a8eab92a1a9e2fc.svg";
export { ForwardRef as ReactComponent };